import React from 'react';

import HandsRaisedIcon from '../assets/hands_raised.svg';
import MapIcon from '../assets/map.svg';

const infoSections = [
  {
    icon: <img src={MapIcon} alt="Map showing a path to follow" />,
    name: '6,600+ Official ACT® Questions',
    text: "Our self-paced ACT® prep course includes over 6,600 ACT® practice questions used under license from the makers of the test, so you know you're studying exactly what you'll see on test day."
  },
  {
    icon: <img src={HandsRaisedIcon} alt="Hands raised in the air" />,
    name: 'Improve Your ACT Score, Guaranteed!',
    text: 'Magoosh has full-length practice tests, expert video lessons, graded writing assignments, custom study schedules and more.'
  }
];

export default { infoSections };
